// common/tableUtils.ts
import { Box, Button } from "@mui/material";
import { MRT_ColumnDef, MRT_Row, MRT_RowData } from "material-react-table";
import {
  CONNECTION_FROM_COLUMN_ID,
  CONNECTION_TO_COLUMN_ID,
} from "./entities/EntityUtils";

/**
 * The column holding the anchor entity, given the direction its edges were
 * fetched in. A connection table always fetches by `anchorEntity._id` on one
 * side, so that side repeats the page's entity on every row and carries no
 * information.
 */
export const anchorConnectionColumnId = (
  direction: "inbound" | "outbound"
): typeof CONNECTION_FROM_COLUMN_ID | typeof CONNECTION_TO_COLUMN_ID =>
  direction === "outbound"
    ? CONNECTION_FROM_COLUMN_ID
    : CONNECTION_TO_COLUMN_ID;

/**
 * The id material-react-table resolves a column def to: its explicit `id`,
 * falling back to the `accessorKey`.
 */
export const getColumnId = <T extends MRT_RowData>(
  column: MRT_ColumnDef<T, any>
): string | undefined => column.id ?? (column as { accessorKey?: string }).accessorKey;

export const renderRowUpdateAction =
  <T extends MRT_RowData>(onClick: (data: T) => void) =>
  ({ row }: { row: MRT_Row<T> }) =>
    [
      <Button
        key="update"
        variant="contained"
        color="light"
        onClick={() => onClick(row.original)}
      >
        Update
      </Button>,
    ];

export const renderRowViewAndUpdateActions =
  <T extends MRT_RowData>(
    onViewClick: (data: T) => void,
    onUpdateClick: (data: T) => void
  ) =>
  ({ row }: { row: MRT_Row<T> }) => (
    <Box sx={{ display: "flex", gap: 1 }}>
      <Button
        variant="contained"
        color="light"
        onClick={() => onViewClick(row.original)}
      >
        View
      </Button>
      <Button
        variant="contained"
        color="light"
        onClick={() => onUpdateClick(row.original)}
      >
        Update
      </Button>
    </Box>
  );

